import React, { useState, useRef, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    safeInsertCSSRules();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);

      // Start fade-out animation
      setIsAnimatingOut(true);

      // Wait for animation to finish (match duration below)
      setTimeout(() => {
        onLogin();
      }, 400); // duration should match animation length in ms
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  return (
    <div
      style={{
        ...styles.container,
        animation: isAnimatingOut ? 'fadeOut 0.4s ease forwards' : 'fadeIn 0.5s ease',
      }}
      ref={formRef}
    >
      <form onSubmit={handleSubmit} style={styles.form}>
        <h1 style={styles.brand}>Formal Invites</h1>
        <h2 style={styles.title}>Admin Login</h2>

        <input
          type="email"
          placeholder="Admin email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />

        <button type="submit" style={styles.button}>Login</button>
        {error && <p style={styles.error}>{error}</p>}
      </form>
    </div>
  );
}

const styles = {
  container: {
    height: '100vh',
    backgroundColor: '#f8f8f8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    backgroundColor: '#fff',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
    maxWidth: '340px',
    width: '100%',
    textAlign: 'center',
    transition: 'transform 0.3s ease',
  },
  brand: {
    fontFamily: "'Great Vibes', cursive",
    fontSize: '36px',
    marginBottom: '20px',
    color: '#f8a4c1',
  },
  title: {
    fontSize: '18px',
    marginBottom: '20px',
    color: '#333',
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: '16px',
    outline: 'none',
    transition: 'border 0.2s',
  },
  button: {
    backgroundColor: '#f8a4c1',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.3s ease',
  },
  error: {
    color: 'red',
    marginTop: '12px',
  },
};

// Safari-safe CSS injection
function safeInsertCSSRules() {
  const styleEl = document.createElement('style');
  styleEl.setAttribute('type', 'text/css');
  document.head.appendChild(styleEl);

  const sheet = styleEl.sheet;

  if (!sheet) return;

  try {
    sheet.insertRule(`
      @keyframes fadeIn {
        from { opacity: 0; transform: scale(0.98); }
        to { opacity: 1; transform: scale(1); }
      }
    `, sheet.cssRules.length);

    sheet.insertRule(`
      @keyframes fadeOut {
        from { opacity: 1; transform: scale(1); }
        to { opacity: 0; transform: scale(0.98); }
      }
    `, sheet.cssRules.length);

    sheet.insertRule(`
      button:hover {
        background-color: #f48bb1 !important;
        transform: scale(1.03);
      }
    `, sheet.cssRules.length);

    sheet.insertRule(`
      input:focus {
        border: 1px solid #f8a4c1 !important;
      }
    `, sheet.cssRules.length);
  } catch (err) {
    console.error('Style insertion failed:', err);
  }
}
